<div class="row">
  <div class="col">
    <mat-form-field class="mb-2" appearance="fill" style="width: 100%">
      <mat-label>{{ shortAnswer.label }}</mat-label>
      <input
        matInput
        type="text"
        [formControl]="control"
        [required]="shortAnswer.isRequired"
        [placeholder]="shortAnswer.placeholder"
      />

      <mat-error *ngIf="control.hasError('required')">
        {{ shortAnswer.label }}&nbsp;{{
          'workflow.request-document.basic-details.required-error' | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>
</div>
